export const wheelsTvKeys = {
  all: () => ['WHEELS_TV_LIST'],
};
